<template>
  <v-alert
    v-model="alertdata.show"
    dismissible
    :type="alertdata.type">
    {{ alertdata.text }}
  </v-alert>
</template>
<script>
  export default {
    props: ['alertdata'],
    data: () => ({
    }),
  };
</script>